import { render } from "./AppTopBar.vue?vue&type=template&id=877dd77a&scoped=true&ts=true"
import script from "./AppTopBar.vue?vue&type=script&lang=ts"
export * from "./AppTopBar.vue?vue&type=script&lang=ts"

import "./AppTopBar.vue?vue&type=style&index=0&id=877dd77a&lang=scss&scoped=true"

import exportComponent from "/var/www/dashboard_viomba_com/25/public/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-877dd77a"]])

export default __exports__